<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>{{spuName}}商品管理</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
               <el-form-item label="品牌:" prop="skuCode" v-if="originFlag">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.placeOfOriginValue"></el-input>
              </el-form-item>
               <el-form-item label="商品编码:" prop="skuCode">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.skuCode"></el-input>
              </el-form-item>
              <el-form-item label="商品名称:" prop="skuName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.skuName"></el-input>
              </el-form-item>
              <el-form-item label="创建人:" prop="createUser">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.createUser"></el-input>
              </el-form-item>
              <el-form-item label="状态:" prop="validFlg">
                <el-select v-model="searchFrom.validFlg" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in statusOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='000P00JB00C' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetClick" btnCode='000P00JB00D' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addBtnClick"  btnCode='000P00JB00E' v-if="btnFlg[2]">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick" btnCode='000P00JB00F' v-if="btnFlg[3]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="delClick" v-if="delBtnShow && btnFlg[4]" btnCode='000P00JB00G'>删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="backTo"  >返回上一级</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click="dianjixuanzhong"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="sku_code"    label="商品编码"  align="center" ></el-table-column>
        <el-table-column prop="sku_name"   label="商品名称" align="center" ></el-table-column>
        <el-table-column v-for="(item,index) in tableHeardArr" :key="index" :prop="item.attrStandard + '_value'"  :label="item.attrName">
        </el-table-column>
        <el-table-column prop="create_user" label="创建人"  align="center" ></el-table-column>
        <el-table-column prop="create_time" label="创建日期" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="valid_flg"   label="状态" align="center">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.valid_flg =='1'" >启用</span>
            <span v-if="scope.row.valid_flg =='0'" >停用</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="remark" label="操作"  align="center"  >
          <template slot-scope="scope"><div>
            <el-button @click="handleClick(scope.row)" type="text" size="small" v-if="scope.row.valid_flg =='1'">停用</el-button>
            <el-button @click="handleClick(scope.row)" type="text" size="small" v-if="scope.row.valid_flg =='0'">启用</el-button>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNum"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addMark"
    width="900px"
    center>
      <span>
         <el-form
          :model="addFrom"
          ref="addFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="140px" size="mini">
          <el-form-item  label="商品名称"
          prop='skuName'
          style="margin-top:10px;">
             <el-input v-model="addFrom.skuName" style="width:210px;" :validate-event = "false"></el-input>
          </el-form-item>
        <div class="addinpBox" v-for="(item,index) in addFrom.formDataArr"  :key="index">
          <!--:prop="item.isnotFlg == '1' ? 'inputRules':''" prop="skuName"       value=value.replace(/\D/g,'').replace(/....(?!$)/g,'$& ')-->
            <!--整数-->
            <!--无校验--->
            <el-form-item  :label="item.attrName + ':'"  v-if="item.attrCode == '' &&  item.attrDatatype == '1' && item.isnotFlg == '0' && item.dicList.length == '0'"  style="margin-top:20px;">
               <el-input v-model="item.ext3" v-number-input.float="0"  style="width:210px;"   :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--有校验-->
            <el-form-item  :label="item.attrName  + ':'"
              v-if="item.attrCode == '' &&  item.attrDatatype == '1' && item.isnotFlg == '1' && item.dicList.length == '0'"  :prop="'formDataArr.' + index + '.ext3'" :key="index"
              :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
              style="margin-top:20px;">
               <el-input v-model="item.ext3" v-number-input.float="0"  style="width:210px;" :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--非整数-->
            <!--无校验--->
            <el-form-item  :label="item.attrName + ':'" v-if="item.attrCode == '' &&  item.attrDatatype == '2' && item.isnotFlg == '0' && item.dicList.length == '0'"  style="margin-top:20px;">
               <el-input v-model="item.ext3" v-number-input.float="3"  style="width:210px;" :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--有校验-->
            <el-form-item  :label="item.attrName + ':'"
            v-if="item.attrCode == '' &&  item.attrDatatype == '2' && item.isnotFlg == '1' && item.dicList.length == '0'"  :prop="'formDataArr.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
            style="margin-top:20px;">
               <el-input v-model="item.ext3" v-number-input.float="3" style="width:210px;" :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--文本-->
            <!--无校验--->
            <el-form-item  :label="item.attrName + ':'"  v-if="item.attrCode == '' &&  item.attrDatatype == '3' && item.isnotFlg == '0' && item.dicList.length == '0'"  style="margin-top:20px;">
               <el-input v-model="item.ext3" type="text" style="width:210px;" :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--有校验-->
            <el-form-item  :label="item.attrName + ':'"  :prop="'formDataArr.' + index + '.ext3'" :key="index"
             v-if="item.attrCode == '' &&  item.attrDatatype == '3' && item.isnotFlg == '1' && item.dicList.length == '0'"
              :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
             style="margin-top:20px;">
               <el-input v-model="item.ext3" type="text" style="width:210px;" :validate-event = "false"></el-input> {{item.unitType}}
            </el-form-item>
            <!--无校验--->
            <el-form-item  :label=" item.attrName +  ':'" v-else-if="item.dicList != [] && item.attrCode != '' &&  item.isnotFlg == '0'"  style="margin-top:20px;">
                <el-select :validate-event = "false" ref="selectref" v-model="item.ext3" filterable :id="item.attrStandard">
                <span   >
                   <el-option
                      v-for="(item) in item.dicList"
                      :key="item.itemNo"
                      :label="item.showName"
                      :value="item.itemNo">
                  </el-option>
                </span>
                 </el-select>
            </el-form-item>
            <!--有校验--->
            <el-form-item  :label="item.attrName + ':'"
            v-else-if="item.attrCode != '' && item.dicList != [] && item.isnotFlg == '1'"  :prop="'formDataArr.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'change' },
              ]"
            style="margin-top:20px;">
                <el-select :validate-event = "false" ref="selectref" v-model="item.ext3" filterable :id="item.attrStandard">
                <span v-for="(item,index) in item.dicList" :key="index"  >
                   <el-option
                      :label="item.showName"
                      :value="item.itemNo">
                  </el-option>
                </span>
                 </el-select>
            </el-form-item>
            <!--无校验--->
            <el-form-item  :label="item.attrName + ':'" v-else-if="item.attrCode == '' && item.attrDatatype == '4' && item.isnotFlg == '0'"  style="margin-top:20px;">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="item.ext3"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :validate-event = "false"
                  style="width:210px;"
                  >
                </el-date-picker>
            </el-form-item>
            <!--有校验-->
            <el-form-item  :label="item.attrName + ':'"
            v-else-if="item.attrCode == '' && item.attrDatatype == '4' && item.isnotFlg == '1'"  :prop="'formDataArr.' + index + '.ext3'" :key="index"
            :rules="[
                { required: true, message: '此项不能为空', trigger: 'blur' },
              ]"
            style="margin-top:20px;">
                <el-date-picker
                  placeholder="选择日期"
                  v-model="item.ext3"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :validate-event = "false"
                  style="width:210px;"
                  >
                </el-date-picker>
            </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addSubmit('addFrom')" :loading='addLoading' v-if="addBtnShow">保存</el-button>
        <el-button type="primary" size='mini'   @click="changeSubmit('addFrom')" :loading='changeLoading' v-if="changeBtnShow">修改</el-button>
        <el-button @click="addSpuClose('addFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  skuTableHead, // 表头
  skuList, // 查询列表
  skuAdd, // 新增
  seeGroupType, // 获取下拉框数据
  skuUpdate, // 修改
  skuDelete, // 删除
  skuUpdateStatus // 启用/停用
} from '@/api/spu'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
export default {
  components: {},
  data () {
    return {
      originFlag: false,
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00JB00C', '000P00JB00D', '000P00JB00E', '000P00JB00F', '000P00JB00G'],
      spuId: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        // spuId:this.$route.params.spuId,
        placeOfOriginValue: '',
        spuId: localStorage.getItem('spuId'),
        pageNum: 1,
        pageSize: 10
      },
      statusOptions: [{
        value: '1',
        label: '启用'
      }, {
        value: '0',
        label: '停用'
      }],
      value: '',
      tableList: [],
      tableHeardArr: [],
      attrName: '', // 表头信息
      // 新增
      addLoading: false,
      rules: {
        skuName: [
          { required: true, message: '商品名称为空！', trigger: 'blur' }
        ]
        // dateRules:[
        //   { required: true, message: '此项不能为空！', trigger: 'blur' },
        // ],
        // inputRules:[
        //   { required: true, message: '此项不能为空！', trigger: 'blur' },
        // ],
        // seletRules:[
        //   { required: true, message: '请选择活动区域', trigger: 'change' }
        // ]
      },
      bianMaOptions: [],
      dataTypeOptions: [],
      jiLiangDanWeiOptions: [],
      selectOptions: [],
      selectData: '',
      addBtnShow: false,
      changeBtnShow: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      addMark: false, // 新增弹框
      changeLoading: false,
      addFrom: {
        skuName: '',
        formDataArr: [{
          attrName: '',
          ext3: '',
          isnotFlg: ''
        }]
      },
      xuanzhongArr: [],
      delBtnShow: true,
      spuName: ''
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.spuId = localStorage.getItem('spuId')
    this.spuName = localStorage.getItem('spuName')
    this.getTabHeard()
    this.btnFlg = getBtn(this.btnIdArr, '/productManagement/spuManagement')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // 表头
    getTabHeard () {
      skuTableHead({
        spuId: this.spuId
      }).then(res => {
        this.tableHeardArr = res

        this.addFrom.formDataArr = res
        // attrDatatype  1 整形 2菲整形  3文本 4日期
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    rederModel: function (item) {
      return this.addFrom[item.attrCode]
    },
    // 查询接口
    getSeatchData () {
      skuList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.tableList.forEach((item, index) => {
          console.log(item.place_of_origin, 'item.place_of_origin')
          if (item.place_of_origin ) {
            this.originFlag = true
          } else {
            this.originFlag = false
          }
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    resetClick () {
      this.searchFrom = {
        placeOfOriginValue: '',

        spuId: this.spuId,
        pageNum: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNum = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击修改按钮
    changeBtnClick (row) {
      // let selectData = this.$refs.tableRef.selection
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.valid_flg == '1') {
        DonMessage.error('启用状态下的数据不能修改！')
      } else {
        this.addMark = true
        this.title = '修改' + this.spuName + '商品'
        this.addBtnShow = false
        this.changeBtnShow = true
        // this.getTabHeard()
        this.addFrom.skuName = this.xuanzhongArr.sku_name
        let str = ''
        let str1 = ''
        let selectId = ''
        this.$nextTick(() => {
          // console.log(this.$refs.selectref,'11111')
          this.addFrom.formDataArr.forEach((item, index) => {
            if (item.ext3 == undefined) {
              item.ext3 = ''
            }
            str = item.attrStandard + '_value'
            str1 = item.attrStandard + '_id'
            item.ext3 = this.xuanzhongArr[str]
            if (item.attrCode != '' || item.attrCode != null) {
              if (this.$refs.selectref != undefined) {
                this.$refs.selectref.forEach((a, index) => {
                  // console.log(a.id,'22222')
                  if (a.id == item.attrStandard) {
                    item.ext3 = this.xuanzhongArr[str1]
                  // this.$set(this.formDataArr, item.ext3, this.xuanzhongArr[str])
                  // console.log(item.ext3)
                  }
                })
              }
            }
          })
        })
      }
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击删除
    delClick () {
      // console.log(this.xuanzhongArr,'222')
      // let selectData = this.$refs.tableRef.selection
      // console.log(selectData.length,'222')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.valid_flg == '1') {
        DonMessage.error('启用状态下的数据不能删除！')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            skuDelete({
              id: this.xuanzhongArr.id, // id
              spuId: this.spuId
            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.getSeatchData(this.searchFrom)
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          })
          .catch(() => {})
      }
    },
    // 点击新建按钮
    addBtnClick () {
      this.addMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.title = '新增' + this.spuName + '商品'
      this.getTabHeard()
      this.addFrom = {}
    },
    // 点击启用/停用
    handleClick (row) {
      let status = ''
      if (row.valid_flg == '0') {
        status = '1'
      } else {
        status = '0'
      }
      this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          skuUpdateStatus({
            validFlg: status,
            id: row.id, // id
            spuId: this.spuId
          })
            .then(res => {
              DonMessage.success('操作成功!')
              this.getSeatchData(this.searchFrom)
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        })
        .catch(() => {})
    },
    // 点击新增确定
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          let name = '{ "spuId":"' + this.spuId + '","skuName":"' + this.addFrom.skuName + '",'
          this.addFrom.formDataArr.forEach((item, index) => {
            if (index != '0') {
              name += ','
            }
            name += "'" + item.attrStandard + "_value':'" + item.ext3 + "'"
            if (index == this.addFrom.formDataArr.length - 1) {
              name += '}'
            }
          })
          // console.log(name,'333333')
          skuAdd({
            params: name
          }).then(res => {
            this.$message.success('添加成功！')
            this.addLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.addLoading = false
            this.$message.error(err.message)
          })
          // console.log(name)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 修改确定
    changeSubmit (formName) {
      // console.log(this.addFrom.formDataArr)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          let name = '{"id":"' + this.xuanzhongArr.id + '", "spuId":"' + this.spuId + '","skuName":"' + this.addFrom.skuName + '",'
          this.addFrom.formDataArr.forEach((item, index) => {
            if (item.ext3 == undefined) {
              item.ext3 = ''
            }
            if (index != '0') {
              name += ','
            }
            name += "'" + item.attrStandard + "_value':'" + item.ext3 + "'"
            if (index == this.addFrom.formDataArr.length - 1) {
              name += '}'
            }
          })
          skuUpdate({
            params: name
          }).then(res => {
            this.$message.success('修改成功！')
            this.changeLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.changeLoading = false
            this.$message.error(err.message)
          })
          // console.log(name)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 取消
    addSpuClose (formName) {
      this.$refs[formName].resetFields()
      this.addMark = false
      // console.log('2222')
    },
    // 返回spu页面
    backTo () {
      this.$router.push('/productManagement/spuManagement')
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 10px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
